import {
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectIssueStatusesApi = createApi({
  reducerPath: "projectIssueStatusesApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectIssueStatuses: build.query({
      query: () => 'projectIssueStatuses',
      transformResponse: (response: { data: { id: number; code: string; name: string }[] }) => response.data,
    }),
  }),
});

export const { useGetProjectIssueStatusesQuery } = projectIssueStatusesApi;
